import equals from 'ramda/src/equals'
import difference from 'ramda/src/difference'
import isEmpty from 'ramda/src/isEmpty'
import answerModule from '@/store/modules/answer.module'

class AnswerRefsResolver {
  constructor(convJson) {
    this.currentAnswerRefsIds = this._findAnswerRefsIds(convJson)
  }

  deletes = () => answerModule.answerRefs().deletes
  creates = () => answerModule.answerRefs().creates

  resolveAnswerRefs(convJson) {
    const answerRefsIds = this._findAnswerRefsIds(convJson)
    if (equals(answerRefsIds, this.currentAnswerRefsIds)) return

    const deletedAnswerRefsIds = this._findMissingAnswerRefsIds(answerRefsIds)
    const newAnswerRefsIds = this._findNewAnswerRefsIds(answerRefsIds)
    if (!isEmpty(deletedAnswerRefsIds)) this._resolveDeletes(deletedAnswerRefsIds)
    if (!isEmpty(newAnswerRefsIds)) this._resolveCreates(newAnswerRefsIds)

    this.currentAnswerRefsIds = answerRefsIds
  }

  _findAnswerRefsIds(convJson) {
    const answerRefsIdSet = new Set()
    this._findUniqueAnswerRefsIds(convJson, answerRefsIdSet)
    return Array.from(answerRefsIdSet)
  }

  _findUniqueAnswerRefsIds(convJson, answerRefsIdSet) {
    const stringedConvJson = JSON.stringify(convJson)
    const answerRefRegex = /ref:answer:([^"]+)/g
    const matches = Array.from(stringedConvJson.matchAll(answerRefRegex))
    matches.forEach(match => answerRefsIdSet.add(match[1]))
  }

  _resolveDeletes(deletedAnswerRefsIds) {
    const createsWithoutLocalDeletes = difference(this.creates(), deletedAnswerRefsIds)
    if (!equals(this.creates(), createsWithoutLocalDeletes)) {
      answerModule.setAnswerRefsCreates(createsWithoutLocalDeletes)
    } else if (!isEmpty(deletedAnswerRefsIds)) {
      answerModule.setAnswerRefsDeletes([...deletedAnswerRefsIds, ...this.deletes()])
    }
  }
  
  _resolveCreates(createdAnswerRefsIds) {
    const deletesWithoutLocalCreates = difference(this.deletes(), createdAnswerRefsIds)
    if (!equals(this.deletes(), deletesWithoutLocalCreates)) {
      answerModule.setAnswerRefsDeletes(deletesWithoutLocalCreates)
    } else if (!isEmpty(createdAnswerRefsIds)) {
      answerModule.setAnswerRefsCreates([...createdAnswerRefsIds, ...this.creates()])
    }
  }

  _findMissingAnswerRefsIds(newAnswerRefsIds) {
    return difference(this.currentAnswerRefsIds, newAnswerRefsIds)
  }

  _findNewAnswerRefsIds(newAnswerRefsIds) {
    const currentAnswerRefsIdsSet = new Set(this.currentAnswerRefsIds)
    const newAnswerRefsIdsSet = new Set(newAnswerRefsIds)
    return [...newAnswerRefsIdsSet].filter(value => !currentAnswerRefsIdsSet.has(value))
  }
}

export default AnswerRefsResolver
